<template>
    <div class="detail-box">
        <div class="detail-item">
            <div class="item-title">
                项目设置
            </div>
            <div class="safe-item__wrapper">
                <div class="safe-item__box">
                    <div :class="(info.auto_confirm ? 'checked ' : '') + 'icon'">
                        <v-svg-icon
                            name="icon-baohu"
                        />
                    </div>
                    <div class="title">
                        自动确认
                    </div>
                    <div class="desc">
                        系统帮您确认服务人员，服务更迅速
                    </div>
                    <div :class="(info.auto_confirm ? '' : 'text-danger ') + 'status'">
                        {{ info.auto_confirm ? '已开启' : '未开启' }}
                    </div>
                    <div class="handler">
                        <el-button
                            v-if="info.auto_confirm"
                            size="small"
                            type="text"
                            @click="handleChange(0)"
                        >
                            关闭
                        </el-button>
                        <el-button
                            v-else
                            size="small"
                            type="text"
                            @click="handleChange(1)"
                        >
                            开启
                        </el-button>
                    </div>
                </div>
                <div class="safe-item__box">
                    <div :class="(info.auto_confirm ? 'checked ' : '') + 'icon'">
                        <v-svg-icon
                            name="icon-baohu"
                        />
                    </div>
                    <div class="title">
                        服务成果附件验证
                    </div>
                    <div class="desc">
                        要求服务人员提交服务成果必须包含照片、PDF、Excel等附件
                    </div>
                    <div :class="(info.pics_status ? '' : 'text-danger ') + 'status'">
                        {{ info.pics_status ? '已开启' : '未开启' }}
                    </div>
                    <div class="handler">
                        <el-button
                            v-if="info.pics_status"
                            size="small"
                            type="text"
                            @click="handleChangeAttachment(0)"
                        >
                            关闭
                        </el-button>
                        <el-button
                            v-else
                            size="small"
                            type="text"
                            @click="handleChangeAttachment(1)"
                        >
                            开启
                        </el-button>
                    </div>
                </div>
<!--                服务成果审核    开启后服务成果增加审核流程，并且结算时校验是否审核通过-->
                <div class="safe-item__box">
                    <div :class="(info.work_status ? 'checked ' : '') + 'icon'">
                        <v-svg-icon
                            name="icon-baohu"
                        />
                    </div>
                    <div class="title">
                        服务成果审核
                    </div>
                    <div class="desc">
                        开启后服务成果增加审核流程，并且结算时校验是否审核通过
                    </div>
                    <div :class="(info.work_status ? '' : 'text-danger ') + 'status'">
                        {{ info.work_status ? '已开启' : '未开启' }}
                    </div>
                    <div class="handler">
                        <el-button
                            v-if="info.work_status"
                            size="small"
                            type="text"
                            @click="handleChangeAudit(0)"
                        >
                            关闭
                        </el-button>
                        <el-button
                            v-else
                            size="small"
                            type="text"
                            @click="handleChangeAudit(1)"
                        >
                            开启
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
export default {
    name: 'ProSetting',
    data () {
        return {
            statusList: ['未设置', '已设置'],
            info: {},
            phone: '',
            payPWD: -1
        }
    },
    mounted () {
        this.updateProfile()
    },
    methods: {
        handleChange (status) {
            this.$confirm(`此操作将${status * 1 ? '开启' : '关闭'}自动接单功能, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.changeAutoConfirm(status)
            }).catch(() => {})
        },
        handleChangeAttachment (status) {
            this.$confirm(`此操作将${status * 1 ? '开启' : '关闭'}服务成果附件验证功能, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.changeAttachment(status)
            }).catch(() => {})
        },
        changeAttachment (status) {
            this.$http.post('/api/user/setservicepics', qs.stringify({
                status
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            type: 'success',
                            message: `服务成果附件验证功能已${status * 1 ? '开启' : '关闭'}`
                        })
                        this.updateProfile()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        changeAutoConfirm (status) {
            this.$http.get('/api/user/setconfirmstatus', {
                params: {
                    status
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            type: 'success',
                            message: `自动接单功能已${status * 1 ? '开启' : '关闭'}`
                        })
                        this.updateProfile()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleChangeAudit (status) {
            this.$confirm(`此操作将${status * 1 ? '开启' : '关闭'}服务成果审核功能, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.changeAudit(status)
            }).catch(() => {})
        },
        changeAudit (status) {
            this.$http.post('/api/user/setservice', qs.stringify({
                status
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            type: 'success',
                            message: `服务成果审核功能已${status * 1 ? '开启' : '关闭'}`
                        })
                        this.updateProfile()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        updateProfile () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                        localStorage.setItem('USERINFO', JSON.stringify(res.data))
                        // this.getPhone()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";

    .detail-box {
        .detail-item {
            padding-left: 0;
        }
    }
</style>
